import React from 'react';
import { Input, Button, Textarea, Table, Select, SelectSearch } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import moment from 'moment';
import { PinIcon, ArrowLeft, ArrowRightBlack, ArrowLeftBlack, CheckWhiteIcon, AddWhiteIcon, EditIcon, TrashIcon, AddIcon, CheckGreenIcon } from 'assets/icons';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import { ClientQuoteService, ClientProfileService, ProfileService, QuoteService } from 'services';
import addCurrentLocation from 'google-maps-current-location';
import { connect } from 'react-redux';

interface Props extends RootState, RouteComponentProps {
	onClose?: any;
	dispatch: any;
	user_id_from_clients?: any;
}

// @ts-ignore
const google = window.google;

const DEFAULT_LOCATION = {
	latitude: '10.48801',
	longitude: '-66.87919'
}

declare var window: any;

const INITIAL_STATE_FORM = {
	area_id: '',
	area: '',
	date: moment().add(2,'days').format('YYYY-MM-DD'),
	type_id: Constants.QUOTE_TYPES.NORMAL.toString(),
	comments: '',
	journey_id: '',
	payment_method_id: '',
	service_id: '',
	client_id: '',
	discount: ''
}

const INITIAL_STATE	= {
	state_id: '',
	city_id: '',
	municipality_id: '',
	address: '',
	indications: '',
	information: '',
	name: '',
	latitude: '',
	longitude: ''
}

class ModalCreate extends React.Component<Props> {

	calendar: any;

	state = {
		currentYear: moment().format('YYYY'),
		currentMonth: moment().format('MMMM'),
		accessories: [],
		form: INITIAL_STATE_FORM,
		latitude: null,
		longitude: null,
		journeys: [],
		loading_journeys: false,
		quote_types: [],
		holidays: [],
		special_days: [],
		service: null,
		price_per_meter: null,
		quotes: [],
		user_address: INITIAL_STATE,
		user_addresses: [],
		add_new: false,
		states: [],
		cities: [],
		municipalities: [],
		error_map: false,
		selected_address: null,
		clients: [],
		services: [],
		banks: [],
		payment_methods: [],
		bank_accounts: [],
		urgent_prices: [],
		multiples_dates: false,
		days_selected: [],
		surcharges: 0,
		special_day_price: 0,
		special_day_price_accessories: 0,
		excluded_places: [],
		journey_surcharge: 0,
		quote_limit: 4
	}

	async componentDidMount() {
		if (this.props.user_id_from_clients) {
			await this.setState({
				form: {
					...this.state.form,
					client_id: this.props.user_id_from_clients
				}
			});
		}

		this.requestLocation();
		this.loadClients();
	}

	loadClients = async () => {
		const res: any = await QuoteService.admin.getClients();
		this.setState({
			clients: res.clients,
			quote_types: res.quote_types,
			services: res.services,
			payment_methods: res.payment_methods.filter((item: any) => [Constants.PAYMENT_METHODS.STRIPE,Constants.PAYMENT_METHODS.CORPORATE].indexOf(item.id) == -1),
			bank_accounts: res.bank_accounts,
			banks: res.banks
		});
	}

	load = async (withoutLoading: boolean = false) => {
		if (this.state.form.client_id && this.state.form.service_id) {
			// @ts-ignore
			const res: any = await ClientQuoteService.client.viewService({
				service_id: this.state.form.service_id,
				user_id: this.state.form.client_id
			});
			if (Globals.checkIfCorporate(this.state.form.client_id)) {
				if (res.service) {
					res.service.price = res.service.price_corporate;
				}
				if (res.urgent_prices) {
					res.urgent_prices.forEach((item: any) => {
						if (item.price_corporate)
							item.price = item.price_corporate;
					});
				}
				if (res.accessories) {
					res.accessories.forEach((item: any) => {
						if (item.price_corporate)
							item.price = item.price_corporate;
					});
				}
				if (res.price_per_meter && res.price_per_meter.price_corporate)
					res.price_per_meter.price = res.price_per_meter.price_corporate;
			}

			if (res.quote_limit <= 0) {
				this.setState({
					form: {
						...this.state.form,
						client_id: ''
					}
				});
				Globals.showError("El cliente ha llegado al límite de citas simultaneas");
				return;
			}

			this.setState({
				service: res.service,
				holidays: res.holidays,
				user_addresses: res.user_addresses,
				states: res.states,
				quote_types: res.quote_types,
				price_per_meter: res.price_per_meter,
				urgent_prices: res.urgent_prices,
				accessories: res.accessories,
				urgent_available: res.urgent_available,
				special_days: res.special_days || [],
				special_day_price: res.special_day_price || 0,
				special_day_price_accessories: res.special_day_price_accessories || 0,
				excluded_places: res.excluded_places || [],
				quote_limit: res.quote_limit || 4
			},() => {
				if (this.props.default_address) {
					const index_address = res.user_addresses.findIndex((i: any) => i.id == this.props.default_address);

					if (index_address != -1) {
						this.setState({
							selected_address: index_address
						});
					}
				}

				this.checkInitialDate();
			});
		}
	}

	checkInitialDate = () => {
		// @ts-ignore
		if (this.state.holidays.indexOf(this.state.form.date) != -1) {
			this.setState({
				form: {
					...this.state.form,
					date: moment(this.state.form.date).add(1,'day').format('YYYY-MM-DD')
				}
			},() => this.checkInitialDate());
		}
		else {
			if (!this.state.multiples_dates) {
				this.loadJourneys();
			}
		    this.loadQuotesMonth();

		    this.calculateSurcharges();
		}
	}

	submit = async (e: any) => {
		e.preventDefault();
		const price_per_meter: any = this.state.price_per_meter;
		const service: any = this.state.service;

		// @ts-ignore
		if (this.state.form.discount != '' && (this.state.form.discount < 0 || this.state.form.discount > 100)) {
			Globals.showError("El porcentaje de descuento no es válido");
			return;
		}

		const area_limit = service?.service_areas?.filter((i: any) => {
			return (this.state.form.type_id == Constants.QUOTE_TYPES.CUSTOM.toString() && i.type_id == null) || (!Globals.isQuoteTypeBase(this.state.form.type_id) && i.type_id == this.state.form.type_id);
		}).find((item: any) => item.quantity != 0 && item.quantity != null && item.quantity != '' && item.limit != null && item.limit < item.quantity);

		if (area_limit) {
			if (!this.state.form.area) {
				Globals.showError(`La cantidad de ${ area_limit?.name } no puede ser mayor a ${ area_limit?.limit }`);
				return;
			}
		}

		if (this.state.form.type_id == Constants.QUOTE_TYPES.DEEP.toString()) {
			if (!this.state.form.area) {
				Globals.showError("Debe indicar la cantidad");
				return;
			}
		}
		else if (this.state.form.type_id == Constants.QUOTE_TYPES.URGENT.toString()) {
			if (!this.state.form.area) {
				Globals.showError("Debe indicar la cantidad");
				return;
			}
		}
		else if (this.state.form.type_id == Constants.QUOTE_TYPES.CUSTOM.toString() || !Globals.isQuoteTypeBase(this.state.form.type_id)) {
			// @ts-ignore
			if (this.state.service?.service_areas?.filter((i: any) => {
				return (this.state.form.type_id == Constants.QUOTE_TYPES.CUSTOM.toString() && i.type_id == null) || (!Globals.isQuoteTypeBase(this.state.form.type_id) && i.type_id == this.state.form.type_id);
			}).find((item: any) => item.quantity != 0 && item.quantity != '' && item.quantity != null) == null) {
				Globals.showError("Debe indicar la cantidad de al menos un área");
				return;
			}
		}

		if (this.state.selected_address == null) {
			Globals.showError("Debe seleccionar la dirección");
			return;
		}

		if (!this.state.form.payment_method_id) {
			Globals.showError("Debe seleccionar el método de pago");
			return;
		}

		// @ts-ignore
		const user_address: any = this.state.user_addresses[this.state.selected_address];

		for (let i = 0; i < this.state.excluded_places.length; i ++) {
			const place: any = this.state.excluded_places[i];

			const polygon = new google.maps.Polygon({
		      paths: place?.coords?.map((i: any) => {
	    		return {
	    			lat: parseFloat(i.latitude),
	    			lng: parseFloat(i.longitude)
	    		}
		      })
		    });

		    const center = new google.maps.LatLng(parseFloat(user_address?.latitude || '10.48801'),parseFloat(user_address?.longitude || '-66.87919'));

			const in_polygon = this.checkIfPolygonContains(
				center,
				polygon
			);

			if (in_polygon) {
				Globals.showError("Lo sentimos, la zona indicada en el mapa se encuentra fuera del área del servicio");
				return;
			}
		}

		let city = null;
		let municipality = null;

		const res: any = await ClientQuoteService.client.checkDiscountCode({
			user_id: this.state.form.client_id,
			city_id: user_address?.city_id,
			municipality_id: user_address?.municipality_id
		});
		if (res.city) {
			city = res.city;
		}
		if (res.municipality) {
			municipality = res.municipality;
		}

		let item: any = { ...this.state.form };
		// @ts-ignore
		item.user_address = JSON.stringify(this.state.user_addresses[this.state.selected_address]);

		// @ts-ignore
		item.latitude = this.state.user_addresses[this.state.selected_address].latitude;
		// @ts-ignore
		item.longitude = this.state.user_addresses[this.state.selected_address].longitude;
		
		item.area = this.state.form.area ? (this.state.form.area + ' m2') : '-';
		item.journey = this.state.journeys.find((i: any) => i.id == this.state.form.journey_id);
		if (this.state.form.type_id == Constants.QUOTE_TYPES.DEEP.toString()) {
			// @ts-ignore
			item.price = price_per_meter?.price * parseFloat((this.state.form.area < price_per_meter?.minimum) ? price_per_meter?.minimum : this.state.form.area);
			item.original_price = price_per_meter?.price * parseFloat((this.state.form.area < price_per_meter?.minimum) ? price_per_meter?.minimum : this.state.form.area);
		}
		else if (this.state.form.type_id == Constants.QUOTE_TYPES.CUSTOM.toString() || !Globals.isQuoteTypeBase(this.state.form.type_id)) {
			const service_areas_total = service?.service_areas?.filter((i: any) => {
				return (this.state.form.type_id == Constants.QUOTE_TYPES.CUSTOM.toString() && i.type_id == null) || (!Globals.isQuoteTypeBase(this.state.form.type_id) && i.type_id == this.state.form.type_id);
			}).map((item: any) => (item.quantity || 0) * item.price).reduce((a: number, b: number) => a + b,0);

			item.price = service_areas_total;
			item.original_price = service_areas_total;
		}
		else if (this.state.form.type_id == Constants.QUOTE_TYPES.URGENT.toString()) {
			let urgent_price: any = this.state.urgent_prices.find((i: any) => i.until >= parseFloat(this.state.form.area));

			if (!urgent_price && this.state.urgent_prices.length > 0) {
				urgent_price = this.state.urgent_prices[this.state.urgent_prices.length - 1];
			}

			if (urgent_price) {
				item.price = urgent_price?.price;
				item.original_price = urgent_price?.price;
			}
			else {
				item.price = service?.price;
				item.original_price = service?.price;
			}
		}
		else {
			item.price = service?.price;
			item.original_price = service?.price;
		}

		let accessories_price = 0;
		const accessories = this.state.accessories.filter((i: any) => i.quantity > 0);
		if (accessories.length > 0) {
			accessories_price = accessories.map((i: any) => i.price * i.quantity).reduce((a: number, b: number) => a + b,0);
			item.price += accessories_price;
			item.original_price += accessories_price;
		}

		item.surcharges = this.state.surcharges;
		item.journey_surcharge = this.state.journey_surcharge;
		item.service = service;
		item.service_id = service?.id;
		item.user = this.state.clients.find((item: any) => item.id == this.state.form.client_id);
		item.user_id = this.state.form.client_id;
		item.accessories = JSON.stringify(accessories.map((item: any) => {
			return {
				name: item.name,
				price: item.price,
				accessory_id: item.id,
				quantity: item.quantity
			}
		}))
		item.service_areas = JSON.stringify(service?.service_areas?.filter((i: any) => {
			return (this.state.form.type_id == Constants.QUOTE_TYPES.CUSTOM.toString() && i.type_id == null) || (!Globals.isQuoteTypeBase(this.state.form.type_id) && i.type_id == this.state.form.type_id);
		}).filter((item: any) => item.quantity != 0 && item.quantity != null && item.quantity != '').map((item: any) => {
			return {
				name: item.name,
				price: item.price,
				quantity: item.quantity
			}
		}))

		if (item.type_id == Constants.QUOTE_TYPES.URGENT.toString()) {
			item.date = moment().add(1,'day').format('YYYY-MM-DD');

			// @ts-ignore
			while (this.state.holidays.indexOf(item.date) != -1) {
				item.date = moment(item.date).add(1,'day').format('YYYY-MM-DD');
			}
		}

		let address = '';

		const state: any = this.state.states.find((i: any) => i.id == user_address?.state_id);
		const _address = user_address?.address;

		item.multiples_dates = this.state.multiples_dates;
		item.days_selected = this.state.days_selected; 

		item.city = '';
		if (state) {
			if (item.city)
			    item.city += ' - ';
			item.city += state?.name;
		}
		if (city) {
			if (item.city)
			    item.city += ' - ';
			item.city += city?.name;
		}
		if (municipality) {
			if (item.city)
			    item.city += ' - ';
			item.city += municipality?.name;
		}
		if (_address) {
			if (item.city)
			    item.city += ' - ';
			item.city += _address;
		}
		if (user_address.information) {
			if (item.city)
			    item.city += ' - ';
			item.city += user_address.information;
		}
		if (user_address.indications) {
			if (item.city)
			    item.city += ' - ';
			item.city += user_address.indications;
		}

		let discount_amount = 0;
		if (this.state.form.discount != '') {
			// @ts-ignore
			discount_amount = item.price * (this.state.form.discount / 100);
			item.price = item.price - discount_amount;
		}

		const response: any = await ClientQuoteService.client.create({
			...item,
			hasFile: true,
			registered_by_id: this.props.user?.id,
			origin: Constants.QUOTES_ORIGIN.ADMIN,
			discount_amount
		}).catch(err => {
			Globals.quitLoading();
		});
		this.props.onClose(true);
		Globals.showSuccess("Se ha creado la cita correctamente");
	}

	requestLocation = async () => {
		if (!this.state.latitude && !this.state.longitude) {
			try {
				if (window.webkit && window.webkit.messageHandlers) {
					await this.setState({
			  			latitude: '10.48801',
						longitude: '-66.87919'
			  		});

			  		if (google)
		    			this.setMap();
				}
				else {
					navigator.permissions.query({ name: "geolocation" }).then((permissionStatus) => {
						this.activeGeolocation();

						permissionStatus.onchange = async () => {
							await this.setState({
								error_map: false
							});
					        this.activeGeolocation();
					    }
					});
				}
			}
			catch(e) {
				this.activeGeolocation();
				console.log(e);
			}
		}
		else {
			if (google)
	    		this.setMap();
		}		
	}

	activeGeolocation = async () => {
  		await this.setState({
  			latitude: '10.48801',
			longitude: '-66.87919'
  		});

  		if (google)
			this.setMap();
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	updateDate = () => {
		this.setState({
			currentYear: moment(this.calendar?.getApi().getDate()).format('YYYY'),
			currentMonth: moment(this.calendar?.getApi().getDate()).format('MMMM')
		},() => {
			this.loadQuotesMonth();
		});
	}

	loadJourneys = async () => {
		await this.setState({
			loading_journeys: true
		});
		const res: any = await ClientQuoteService.client.getJourneys({
			date: this.state.form.date && moment(this.state.form.date).format('YYYY-MM-DD'),
			// @ts-ignore
			service_id: this.state.service?.id,
			withoutLoading: true
		});
		this.setState({
			journeys: res.journeys,
			loading_journeys: false
		});
	}

	loadQuotesMonth = async () => {
		const res: any = await ClientQuoteService.client.getQuotesMonth({
			date: moment(this.state.currentYear + '-' + this.state.currentMonth,'YYYY-MMMM').startOf('month').format('YYYY-MM-DD'),
			// @ts-ignore
			service_id: this.state.service?.id,
			withoutLoading: true
		});
		this.setState({
			quotes: res.quotes
		});
	}

	setMap = async () => {
		const map = new google.maps.Map(document.getElementById('map-request-quote'), {
	      zoom: 13,
	      center: new google.maps.LatLng(this.state.user_address?.latitude || '10.48801',this.state.user_address?.longitude || '-66.87919'),
	      draggable: true,
	      zoomControl: true,
	      streetViewControl: false,
	      fullscreenControl: false,
	      scaleControl: false,
	      rotateControl: false
	    });

	    addCurrentLocation(map,{
		  markerStyle: {
			scale: 0
		  },
		  showAccuracyRadius: false
		});

	    const marker = new google.maps.Marker({
	      position: new google.maps.LatLng(this.state.user_address?.latitude || '10.48801',this.state.user_address?.longitude || '-66.87919'),
	      map,
	      title: 'Ubicación',
	      animation: google.maps.Animation.DROP,
	      draggable: true,
	      icon: PinIcon
	    })

	    await this.setState({
			map,
			marker
	    });

	    google.maps.event.addListener(marker,'dragend',(event: any) => {
	    	this.setState({
	    		user_address: {
	    			...this.state.user_address,
	    			latitude: event.latLng.lat(),
	    			longitude: event.latLng.lng()
	    		}
	    	});
	    });

	    google.maps.event.addListener(map,'click',(event: any) => {
	    	this.setState({
	    		user_address: {
	    			...this.state.user_address,
	    			latitude: event.latLng.lat(),
	    			longitude: event.latLng.lng()
	    		}
	    	});

	    	// @ts-ignore
	    	this.state.marker?.setPosition(new google.maps.LatLng(event.latLng.lat(),event.latLng.lng()));
	    });

	    const input = document.getElementById('location-input');
        const autocomplete = new google.maps.places.Autocomplete(input,{
        	componentRestrictions: {
        		country: "ve"
        	}
        });
        google.maps.event.addListener(autocomplete, 'place_changed', () => {
            var place = autocomplete.getPlace();
            const latitude = place.geometry.location.lat();
            const longitude = place.geometry.location.lng();
            this.setState({
            	user_address: {
            		...this.state.user_address,
            		latitude,
            		longitude
            	}
            });
            // @ts-ignore
            document.querySelector('#location-input').value = '';
            map.setCenter(new google.maps.LatLng(latitude,longitude));
            marker.setPosition(new google.maps.LatLng(latitude,longitude));
        });

        if (map) {
        	for (let i = 0; i < this.state.excluded_places.length; i++) {
	        	// @ts-ignore
	        	const coords = this.state.excluded_places[i].coords;

	        	new google.maps.Polygon({
			      paths: coords.map((i: any) => {
		    		return {
		    			lat: parseFloat(i.latitude),
		    			lng: parseFloat(i.longitude)
		    		}
			      }),
				  strokeColor: "#d20b06",
				  strokeOpacity: 0.8,
				  strokeWeight: 2,
				  fillColor: "#d20b06",
				  fillOpacity: 0.35,
				  map
			    });
	        }
        }
	}

	edit = (e: any, item: any, index: number) => {
		e.preventDefault();
		const user_address = this.state.user_addresses[index];
		this.setState({
			active_index: index,
			user_address,
			add_new: true
		},() => {
			setTimeout(() => {
				const element: any = document.getElementById('row-form');
			    if (element) {
			      window.scrollTo({ top: element.offsetTop - 100, behavior: 'smooth' });
			    }
			},100);		
			this.setMap();
			this.getCities();
		});
	}

	delete = (e: any, item: any, index: number) => {
		e.preventDefault();
		const user_addresses = this.state.user_addresses;
		user_addresses.splice(index,1);
		this.setState({
			user_addresses,
			selected_address: null
		},() => this.updateAddresses());
	}

	add = () => {
		const {
			state_id,
			city_id,
			municipality_id,
			address,
			information,
			name,
			indications
		} = this.state.user_address;

		if (!state_id || !city_id || !municipality_id || !address || !name || !indications) {
			Globals.showError("Debe ingresar todos los datos para continuar");
			return;
		}

		for (let i = 0; i < this.state.excluded_places.length; i ++) {
			const place: any = this.state.excluded_places[i];

			const polygon = new google.maps.Polygon({
		      paths: place?.coords?.map((i: any) => {
	    		return {
	    			lat: parseFloat(i.latitude),
	    			lng: parseFloat(i.longitude)
	    		}
		      })
		    });

		    const center = new google.maps.LatLng(parseFloat(this.state.user_address?.latitude || '10.48801'),parseFloat(this.state.user_address?.longitude || '-66.87919'));

			const in_polygon = this.checkIfPolygonContains(
				center,
				polygon
			);

			if (in_polygon) {
				Globals.showError("Lo sentimos, la zona indicada en el mapa se encuentra fuera del área del servicio");
				return;
			}
		}

		let user_addresses: any = [...this.state.user_addresses];
		// @ts-ignore
		if (this.state.active_index != null && user_addresses[this.state.active_index]) {
			// @ts-ignore
			user_addresses[this.state.active_index] = this.state.user_address;
		}
		else {
			user_addresses.push(this.state.user_address);
		}
		this.setState({
			user_addresses,
			add_new: false,
			user_address: INITIAL_STATE,
			active_index: null,
			selected_address: user_addresses.length - 1
		},() => this.updateAddresses());
	}

	updateAddresses = async () => {
		await ClientProfileService.client.updateAddresses({
			// @ts-ignore
			user_id: this.state.form.client_id,
			user_addresses: JSON.stringify(this.state.user_addresses),
			withoutLoading: true
		});
	}

	changeUserAddress = (e: any,callback = () => {}) => {
		this.setState({
			user_address: {
				...this.state.user_address,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	getCities = async () => {
		const res: any = await ProfileService.getCities({
			state_id: this.state.user_address.state_id,
			// @ts-ignore
			user_id: this.state.form.client_id
		});
		this.setState({
			cities: res.cities,
			municipalities: res.municipalities
		});
	}

	addClient = () => {
		this.props.history.replace('/admin/clients?open_create=true');
	}

	calculateSurchargesOLD = async () => {
		let surcharges = 0;
		const journey: any = this.state.journeys.find((i: any) => i.id == this.state.form.journey_id);
		let journey_surcharge = journey?.surcharge || 0;

		if (this.state.multiples_dates) {
			journey_surcharge *= this.state.days_selected.length;
		}

		if (this.state.multiples_dates) {
			const total_accessories = this.state.accessories.filter((i: any) => i.quantity > 0).map((i: any) => i.quantity).reduce((a: number, b: number) => a + b,0) * this.state.special_day_price_accessories;
			let quantity = 0;
			for (let i = 0; i < this.state.days_selected.length; i++) {
				const index = this.state.special_days.map((i: any) => i.day).indexOf(this.state.days_selected[i]);
				if (index != -1) {
					quantity++;
					// @ts-ignore
					surcharges += this.state.special_days[index].price || this.state.special_day_price;
				}
			}
			surcharges += (total_accessories * quantity);
		}
		else {
			const index = this.state.special_days.map((i: any) => i.day).indexOf(this.state.form.date);
			if (index != -1) {
				// @ts-ignore
				surcharges = this.state.special_days[index].price || this.state.special_day_price;
				surcharges += this.state.accessories.filter((i: any) => i.quantity > 0).map((i: any) => i.quantity).reduce((a: number, b: number) => a + b,0) * this.state.special_day_price_accessories;
			}
			else {
				surcharges = 0;
			}
		}

		this.setState({
			surcharges,
			journey_surcharge
		});
	}

	calculateSurcharges = async () => {
		// 1. Aseguramos el tipado numérico desde la inicialización
		let surcharges: number = 0;

		const journey: any = this.state.journeys.find((i: any) => i.id == this.state.form.journey_id);
		let journey_surcharge: number = Number(journey?.surcharge) || 0;

		const isMultipleDates = this.state.multiples_dates;
		const daysSelectedCount = this.state.days_selected?.length || 0;

		if (isMultipleDates) {
			journey_surcharge *= daysSelectedCount;
		}

		// Convertimos la cantidad explícitamente a Number para evitar concatenaciones
		const total_accessories_quantity = this.state.accessories
			.filter((i: any) => Number(i.quantity) > 0)
			.reduce((total: number, current: any) => total + Number(current.quantity), 0);

		const accessories_cost_per_day = total_accessories_quantity * Number(this.state.special_day_price_accessories);

		// 3. Evaluamos recargos por días feriados
		if (isMultipleDates) {
			let special_days_matched = 0;

			for (const day of this.state.days_selected) {
				const specialDay: any = this.state.special_days.find((i: any) => i.day === day);

				if (specialDay) {
					special_days_matched++;
					surcharges += Number(specialDay.price) || Number(this.state.special_day_price);
				}
			}
			surcharges += (accessories_cost_per_day * special_days_matched);

		} else {
			const specialDay: any = this.state.special_days.find((i: any) => i.day === this.state.form.date);

			if (specialDay) {
				const base_surcharge = Number(specialDay.price) || Number(this.state.special_day_price);
				surcharges = base_surcharge + accessories_cost_per_day;
			}
		}

		// 4. Actualizamos el estado
		this.setState({
			surcharges,
			journey_surcharge
		});
	}

	checkIfPolygonContains = (coords: any,polygon: any) => {
		return google.maps.geometry.poly.containsLocation(coords, polygon);
	}
	
	render() {
		const surcharges: any = this.state.surcharges;
		const journey_surcharge: any = this.state.journey_surcharge;
		const service: any = this.state.service;
		const service_areas_total: number = service?.service_areas?.filter((i: any) => {
			return (this.state.form.type_id == Constants.QUOTE_TYPES.CUSTOM.toString() && i.type_id == null) || (!Globals.isQuoteTypeBase(this.state.form.type_id) && i.type_id == this.state.form.type_id);
		}).map((item: any) => (item.quantity || 0) * item.price).reduce((a: number, b: number) => a + b,0);
		// @ts-ignore
		const area_with_price = this.state.service?.service_areas?.filter((i: any) => {
			return (this.state.form.type_id == Constants.QUOTE_TYPES.CUSTOM.toString() && i.type_id == null) || (!Globals.isQuoteTypeBase(this.state.form.type_id) && i.type_id == this.state.form.type_id);
		}).find((item: any) => item.quantity != 0 && item.quantity != '' && item.quantity != null);
		const client: any = this.state.clients.find((item: any) => item.id == this.state.form.client_id);
		const { quotes, add_new, error_map } = this.state;
		const quote_type: any = this.state.quote_types.find((i: any) => i.id == this.state.form.type_id);
		const holidays: any = this.state.holidays || [];
		const is_urgent = this.state.form.type_id == Constants.QUOTE_TYPES.URGENT.toString();
		const price_per_meter: any = this.state.price_per_meter;
		const journeys: any = this.state.journeys.filter((i: any) => {
			const service_journey = service?.service_journeys?.find((item: any) => item.journey_id == i.id);

			if (is_urgent || this.state.multiples_dates) {
				return true;
			}
			else if (i.quantity >= service_journey?.quantity) {
				return false;
			}	

			return true;
		});

		let price = 0;

		if (this.state.form.type_id == Constants.QUOTE_TYPES.DEEP.toString()) {
			price = price_per_meter?.price * parseFloat((this.state.form.area < price_per_meter?.minimum) ? price_per_meter?.minimum : this.state.form.area);
		}
		else if (this.state.form.type_id == Constants.QUOTE_TYPES.CUSTOM.toString() || !Globals.isQuoteTypeBase(this.state.form.type_id)) {
			price = service_areas_total;
		}
		else if (this.state.form.type_id == Constants.QUOTE_TYPES.URGENT.toString()) {
			let urgent_price: any = this.state.urgent_prices.find((i: any) => i.until >= parseFloat(this.state.form.area));

			if (!urgent_price && this.state.urgent_prices.length > 0) {
				urgent_price = this.state.urgent_prices[this.state.urgent_prices.length - 1];
			}

			if (urgent_price) {
				price = urgent_price?.price;
			}
			else {
				price = service?.price;
			}
		}
		else {
			price = service?.price;
		}

		let accessories_price = 0;

		const accessories = this.state.accessories.filter((i: any) => i.quantity > 0);
		if (accessories.length > 0) {
			accessories_price = accessories.map((i: any) => i.price * i.quantity).reduce((a: number, b: number) => a + b,0);
		}

		let discount = 0;

		if (this.state.form.discount != '') {
			// @ts-ignore
			discount = (price + accessories_price) * (this.state.form.discount / 100);
		}

		const quantity_of_days = this.state.multiples_dates ? this.state.days_selected.length : 1;

		return (
			<div id="modal-quotes-create">
				<form onSubmit={ this.submit }>
					<h4 className="title-create-admin">Nueva solicitud de cita</h4>
					<div className="container-padding">
						<div className="row">
							<div className="col-md-4">
								<div className="container-select">
									<SelectSearch
										placeholder="Seleccione"
										label="Cliente"
										onChange={ (client: any) => {
											this.setState({
												form: {
													...this.state.form,
													client_id: client?.value
												}
											},() => this.load());
										} }
										color="white"
										searchRight
										value={ client ? {
											value: client.id,
											label: client.name + ' ' + client.lastname
										} : null }
										options={ this.state.clients.map((item: any) => {
											return {
												label: item.name + ' ' + item.lastname,
												value: item.id
											}
										}) } />
									<Button type="button" className="btn-add" onClick={ () => this.addClient() }>
										<img src={ AddIcon } />
									</Button>
								</div>
							</div>
							<div className="col-md-4">
								<Select
									label="Seleccione un servicio"
									name="service_id"
									onChange={ (e: any) => this.change(e,() => this.load()) }
									value={ this.state.form.service_id }
									options={ this.state.services.map((item: any) => {
										return {
											label: item.name,
											value: item.id
										}
									}) } />
							</div>
						</div>
						{
							this.state.form.client_id && this.state.form.service_id && (
								<div className="row">
									<div className="col-md-12">
										<div className="addresses">
											<div className="text-right">
												<a href="#" className="add-address" onClick={ (e: any) => {
													e.preventDefault();
													this.setState({
														add_new: true,
														active_index: null,
														user_address: INITIAL_STATE
													},() => {
														setTimeout(() => {
															const element: any = document.getElementById('row-form');
														    if (element) {
														      window.scrollTo({ top: element.offsetTop - 100, behavior: 'smooth' });
														    }
														},100);
														this.setMap();
													});
												} }>
													<img src={ AddWhiteIcon } />
													Añadir nueva dirección
												</a>
											</div>

											{
												this.state.user_addresses.length > 0 && (
													<Table data={ this.state.user_addresses.length } header={ [] }>
														{ this.state.user_addresses.map((i: any,index: number) => {
															return (
																<tr key={ index } className={ this.state.selected_address == index ? 'active' : '' }>
																	<td style={{ width: '100%' }}>
																		<table className="table-inside">
																			<tr className={ this.state.selected_address == index ? 'active' : '' }>
																				<td style={{ width: '10%', whiteSpace: 'nowrap' }}>
																					<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,i,index) }>
																						<img src={ EditIcon } />
																					</a>
																					<a className="link-icon" href="#" onClick={ (e: any) => this.delete(e,i,index) }>
																						<img src={ TrashIcon } />
																					</a>
																				</td>
																				<td className="address" style={{ width: '40%' }}>{ i.address }</td>
																				<td className="name" style={{ width: '40%' }}>{ i.name }</td>
																				<td style={{ textAlign: 'right', width: '10%' }}>
																					<div className={ `check ${ this.state.selected_address == index ? 'active' : '' }` } onClick={ (e: any) => {
																						e.preventDefault();
																						if (index == this.state.selected_address) {
																							this.setState({
																								selected_address: null
																							});
																						}
																						else {
																							this.setState({
																								selected_address: index
																							});
																						}

																						this.props.dispatch({
																							type: 'SET_DEFAULT_ADDRESS',
																							payload: i.id
																						});
																					} }>
																						<img src={ CheckWhiteIcon } />
																					</div>
																				</td>
																			</tr>
																		</table>
																		<p className="address-responsive">{ i.address }</p>
																	</td>
																</tr>
															)
														}) }
													</Table>
												)
											}

											{
												this.state.user_addresses.length == 0 && !add_new && (
													<p className="no-addresses">No se han agregado direcciones</p>
												)
											}

											{
												add_new && (
													<React.Fragment>
														<div className="row" id="row-form" style={{ marginTop: '20px' }}>
															<div className="col-md-6">
																<Select
																	label="Estado"
																	name="state_id"
																	onChange={ (e: any) => this.changeUserAddress(e,() => {
																		this.setState({
																			user_address: {
																				...this.state.user_address,
																				city_id: '',
																				municipality_id: ''
																			}
																		},() => this.getCities());
																	}) }
																	value={ this.state.user_address.state_id }
																	options={ this.state.states.map((i: any) => {
																		return {
																			value: i.id,
																			label: i.name
																		}
																	}) } />
															</div>
															<div className="col-md-6">
																<Select
																	label="Ciudad"
																	disabled={ !this.state.user_address.state_id }
																	name="city_id"
																	onChange={ this.changeUserAddress }
																	value={ this.state.user_address.city_id }
																	options={ this.state.cities.map((i: any) => {
																		return {
																			value: i.id,
																			label: i.name
																		}
																	}) } />
															</div>
															<div className="col-md-6">
																<Select
																	label="Municipio"
																	disabled={ !this.state.user_address.state_id }
																	name="municipality_id"
																	onChange={ this.changeUserAddress }
																	value={ this.state.user_address.municipality_id }
																	options={ this.state.municipalities.map((i: any) => {
																		return {
																			value: i.id,
																			label: i.name
																		}
																	}) } />
															</div>
															<div className="col-md-6">
																<Input
																	color="white"
																	value={ this.state.user_address.address }
																	name="address" 
																	label="Dirección"
																	placeholder="Indique la dirección completa"
																	onChange={ this.changeUserAddress } />
															</div>
															<div className="col-md-6">
																<Input
																	color="white"
																	value={ this.state.user_address.indications }
																	name="indications" 
																	label="Indicaciones de la dirección"
																	placeholder="Escribe aquí instrucciones o comentarios"
																	onChange={ this.changeUserAddress } />
															</div>
															<div className="col-md-6">
																<Input
																	color="white"
																	value={ this.state.user_address.information }
																	name="information" 
																	label="Información adicional"
																	placeholder="Ej: Piso/Oficina/Apto"
																	onChange={ this.changeUserAddress } />
															</div>
															<div className="col-md-6">
																<Input
																	color="white"
																	value={ this.state.user_address.name }
																	name="name" 
																	label="Nombre de la dirección"
																	placeholder="Nombre/Indicador de la dirección"
																	onChange={ this.changeUserAddress } />
															</div>
														</div>

														{
															!error_map && (
																<React.Fragment>
																	<label className="location-input-label">Indicar punto en el mapa</label>
																	<input type="text" placeholder="Buscar dirección Google Mapas" id="location-input" />
																</React.Fragment>
															)
														}

														{
															!error_map && (
																<div id="map-request-quote"></div>
															)
														}

														{
															error_map && (
																<div className="location-permission">
																	<p>Para el correcto funcionamiento de la página debe permitir el acceso a su ubicación</p>
																</div>
															)
														}

														<div className="row row-address">
															<div className="col-6">
																<Button type="button" className="btn-cancel-address" onClick={ (e: any) => this.setState({
																	...DEFAULT_LOCATION,
																	add_new: false
																}) }>
																	Cancelar
																</Button>
															</div>
															<div className="col-6">
																<Button type="button" className="btn-submit-address" onClick={ (e: any) => {
																	e.preventDefault();
																	this.add();
																} }>
																	Guardar dirección
																</Button>
															</div>
														</div>
													</React.Fragment>
												)
											}
										</div>
									</div>
									<div className="col-md-4" style={{ paddingTop: '30px' }}>
										{
											service?.type_id == Constants.SERVICE_TYPES.CLEAN && (
												<Select
													label="Tipo de Limpieza"
													name="type_id"
													onChange={ (e: any) => this.change(e,() => {
														if (this.state.form.type_id != Constants.QUOTE_TYPES.CUSTOM.toString() && this.state.form.type_id != Constants.QUOTE_TYPES.NORMAL.toString()) {
															let accessories: any = [...this.state.accessories];
															accessories.forEach((i: any) => i.quantity = 0)
															this.setState({
																accessories
															},() => this.calculateSurcharges());
														}
													}) }
													value={ this.state.form.type_id }
													options={ this.state.quote_types.map((item: any) => {
														return {
															label: item.name,
															value: item.id
														}
													}) } />
											)
										}
									</div>
								</div>
							)
						}
					</div>

					{
						this.state.form.client_id && this.state.form.service_id && (
							<React.Fragment>
								<div className="container-calendar">
									<div className="row">
										{
											this.state.form.type_id != Constants.QUOTE_TYPES.URGENT.toString() && (
												<div className="col-md-5">
													<h3>Seleccione fecha disponible</h3>
													<div className="row">
														<div className="col-lg-6">
															<div className="container-arrow">
																<button type="button" className="btn btn-arrow" onClick={ () => {
																	this.calendar.getApi().prevYear();
																	this.updateDate();
																} }>
																	<img src={ ArrowLeftBlack } />
																</button>
																<h4>{ this.state.currentYear }</h4>
																<button type="button" className="btn btn-arrow" onClick={ () => {
																	this.calendar.getApi().nextYear();
																	this.updateDate();
																} }>
																	<img src={ ArrowRightBlack } />
																</button>
															</div>
														</div>
														<div className="col-lg-6">
															<div className="container-arrow">
																<button type="button" className="btn btn-arrow" onClick={ () => {
																	this.calendar.getApi().prev();
																	this.updateDate();
																} }>
																	<img src={ ArrowLeftBlack } />
																</button>
																<h4>{ this.state.currentMonth }</h4>
																<button type="button" className="btn btn-arrow" onClick={ () => {
																	this.calendar.getApi().next();
																	this.updateDate();
																} }>
																	<img src={ ArrowRightBlack } />
																</button>
															</div>
														</div>
													</div>
													<FullCalendar
														ref={ ref => this.calendar = ref }
												        plugins={[ dayGridPlugin ]}
												        initialView="dayGridMonth"
												        locale="es"
												        dayHeaderContent={ (args: any) => {
												        	return (
												        		<button className="btn day-container day-header">
																	<p>{ args.text.substring(0,2) }</p>
											        			</button>
												        	)
												        } }
											        	dayCellContent={ (info) => {
											        		const date = moment(info.date).format('YYYY-MM-DD');
											        		const journeys: any = this.state.journeys.filter((i: any) => {
																const service_journey = service?.service_journeys?.find((item: any) => item.journey_id == i.id);

																if (quotes.filter((item: any) => item.journey_id == i.id && moment(item.date).format('YYYY-MM-DD') == date).length >= service_journey?.quantity) {
																	return false;
																}	

																return true;
															});

											        		return (
											        			<button type="button" disabled={ 
											        				date == moment().format('YYYY-MM-DD') || 
											        				date == moment().add(1,'day').format('YYYY-MM-DD') || 
											        				date < moment().format('YYYY-MM-DD') || 
											        				date > moment().add(6,'months').format('YYYY-MM-DD') || 
											        				holidays.indexOf(date) != -1
											        			} 
											        			// @ts-ignore
											        			className={ `btn day-container ${ (this.state.form.date == date || this.state.days_selected.indexOf(date) != -1) ? 'active' : '' } ${ (holidays.indexOf(date) != -1) ? 'holiday' : '' }` } 
											        			onClick={ () => this.setState({
											        				form: {
											        					...this.state.form,
											        					date
											        				}
											        			},async () => {
											        				if (this.state.multiples_dates) {
											        					let days_selected = [...this.state.days_selected];
											        					const date: any = this.state.form.date;
											        					// @ts-ignore
											        					if (days_selected.indexOf(date) == -1) {
											        						if (days_selected.length >= this.state.quote_limit) {
												        						Globals.showError(`Solo puede seleccionar ${ this.state.quote_limit } fechas como máximo`);
												        						this.setState({
												        							form: {
												        								...this.state.form,
												        								date: days_selected[days_selected.length - 1]
												        							}
												        						});
												        						return;
												        					}
											        						// @ts-ignore
											        						days_selected.push(date);
											        					}
											        					else {
											        						// @ts-ignore
											        						days_selected.splice(days_selected.indexOf(date),1);
											        					}											        					
											        					await this.setState({
											        						days_selected,
											        						form: {
											        							...this.state.form,
											        							date: ''
											        						}
											        					});
											        				}
											        				else {
											        					this.loadJourneys();
											        				}

											        				this.calculateSurcharges();
											        			}) }>
																	<p>{ moment(info.date).format('D') }</p>
											        			</button>
											        		)
											        	} }
												        headerToolbar={{
												        	left: '',
												        	center: '',
												        	right:  ''
												        }}
												    />

												    <div className="row">
												    	<div className="col-md-6">
												    		<div className="item-color">
													    		<div className="container-green"></div>
													    		<p>Con disponibilidad</p>
												    		</div>
												    	</div>
												    	<div className="col-md-6">
												    		<div className="item-color">
													    		<div className="container-red"></div>
													    		<p>Sin disponibilidad</p>
													    	</div>
												    	</div>
												    </div>

												    {
												    	this.state.quote_limit > 1 && (
														    <div className="container-check-dates" onClick={ () => {
														    	this.setState({
														    		multiples_dates: !this.state.multiples_dates,
														    		days_selected: this.state.multiples_dates ? [] : [this.state.form.date]
														    	},() => {
														    		if (!this.state.multiples_dates) {
														    			this.setState({
														    				form: {
														    					...this.state.form,
														    					date: moment().add(2,'days').format('YYYY-MM-DD')
														    				}
														    			},() => this.checkInitialDate());
														    		}
														    	});
														    } }>
														    	<div className="container-check-active">
																	{ this.state.multiples_dates && <img src={ CheckGreenIcon } /> }
																</div>
																Seleccionar varias fechas
														    </div>
														)
												    }

												    {
												    	this.state.days_selected.map((item: any, index: number) => {
												    		return (
												    			<div className="item-date">
												    				<p>{ moment(item).format('DD/MM/YYYY') }</p>
												    				<img src={ TrashIcon } onClick={ () => {
												    					let days_selected = [...this.state.days_selected];
												    					days_selected.splice(index,1);
												    					this.setState({
												    						days_selected
												    					});
												    				} } />
												    			</div>
												    		)
												    	})
												    }
												</div>
											)
										}
										<div className={ `col-md-${ is_urgent ? '12' : '7' }` }>
											{
												(this.state.form.type_id == Constants.QUOTE_TYPES.DEEP.toString() || this.state.form.type_id == Constants.QUOTE_TYPES.URGENT.toString()) && (
													<>
														<h3>Indique la cantidad</h3>

														<div className="container-select-area">
															<Input
																type="decimal"
																placeholder="Indique la cantidad de m2"
																name="area"
																className="form-group-deep"
																onChange={ this.change }
											                    value={ this.state.form.area } />
											                { this.state.form.type_id == Constants.QUOTE_TYPES.DEEP.toString() && <p className="message-deep">Limpieza desde { Globals.formatMiles(price_per_meter?.price * 100) }. Precio a partir de { price_per_meter?.minimum } metros cuadrados { Globals.formatMiles(price_per_meter?.price) }</p> }						
														</div>
													</>
												)
											}

											{
												(this.state.form.type_id == Constants.QUOTE_TYPES.CUSTOM.toString() || !Globals.isQuoteTypeBase(this.state.form.type_id)) && (
													<>
														<h4 className="accessories-title">Áreas</h4>

														{
															service?.service_areas?.length > 0 && (
																<div className="container-accessories">
																	<div className="row">
																		<div className="col-9">
																			<p className="gray">Área</p>
																		</div>
																		<div className="col-3 text-right">
																			<p className="gray">Precio</p>
																		</div>
																	</div>
																	{
																		service?.service_areas?.map((item: any,index: number) => {
																			if ((this.state.form.type_id == Constants.QUOTE_TYPES.CUSTOM.toString() && item.type_id == null) || (!Globals.isQuoteTypeBase(this.state.form.type_id) && item.type_id == this.state.form.type_id)) 
																				return (
																					<div className={ `row row-item ${ item.active ? 'active' : '' }` }>
																						<div className="col-9">
																							<p>
																								<Input
																									type="number"
																									color="white"
																									value={ item.quantity || '' }
																									name="quantity"
																									onChange={ (e: any) => {
																										let service_areas: any = [...service?.service_areas];
																										service_areas[index].quantity = e.target.value;
																										this.setState({
																											service_areas
																										},() => this.calculateSurcharges());
																									} } />
																								{ item.name } { item.limit != null && `(Máximo ${ item.limit })` }
																							</p>
																						</div>
																						<div className="col-3 text-right">
																							<p className="row-item-price">{ Globals.formatMiles(item.price) }</p>
																						</div>
																					</div>
																				)
																			})
																	}
																</div>
															)
														}
													</>
												)
											}

											{
												(this.state.form.type_id == Constants.QUOTE_TYPES.CUSTOM.toString() || this.state.form.type_id == Constants.QUOTE_TYPES.NORMAL.toString()) && (
													<h4 className="accessories-title">Añadir Complementos <span>(Opcional)</span></h4>
												)
											}

											{
												this.state.accessories.length == 0 && (this.state.form.type_id == Constants.QUOTE_TYPES.CUSTOM.toString() || this.state.form.type_id == Constants.QUOTE_TYPES.NORMAL.toString()) && (
													<p className="no-accessories">No se han encontrado complementos</p>
												)
											}

											{
												this.state.accessories.length > 0 && (this.state.form.type_id == Constants.QUOTE_TYPES.CUSTOM.toString() || this.state.form.type_id == Constants.QUOTE_TYPES.NORMAL.toString()) && (
													<div className="container-accessories">
														<div className="row">
															<div className="col-9">
																<p className="gray">Servicio</p>
															</div>
															<div className="col-3 text-right">
																<p className="gray">Precio</p>
															</div>
														</div>
														{
															this.state.accessories.map((item: any, index: number) => {
																return (
																	<div className={ `row row-item ${ item.active ? 'active' : '' }` }>
																		<div className="col-9">
																			<p>
																				<Input
																					type="number"
																					color="white"
																					value={ item.quantity || '' }
																					name="quantity"
																					onChange={ (e: any) => {
																						let accessories: any = [...this.state.accessories];
																						accessories[index].quantity = e.target.value;
																						this.setState({
																							accessories
																						},() => this.calculateSurcharges());
																					} } />
																				{ item.name }
																			</p>
																		</div>
																		<div className="col-3 text-right">
																			<p className="row-item-price">{ Globals.formatMiles(item.price) }</p>
																		</div>
																	</div>
																)
															})
														}
													</div>
												)
											}
										</div>
									</div>
								</div>
								<h4 className="title-create-admin">Información de pago</h4>
								<div className="container-padding">
									<div className="row">
										<div className="col-md-6">
											<Select
												label="Forma de Pago"
												name="payment_method_id"
												onChange={ (e: any) => this.change(e) }
												value={ this.state.form.payment_method_id }
												options={ this.state.payment_methods.map((item: any) => {
													return {
														value: item.id,
														label: item.name
													}
												}) } />
											<Input
												type="percentage"
												color="white"
												value={ this.state.form.discount }
												name="discount" 
												placeholder="Indique el % de descuento (Opcional)"
												onChange={ this.change } />
										</div>
										<div className="col-md-6 text-right">
											<div>
												<table className="total-table">
													<tr>
														<td className="text-left">Costo Total Servicio</td>
														<td className="bold">{ Globals.formatMiles(price * quantity_of_days) }</td>
													</tr>
													<tr>
														<td className="text-left">Complementos</td>
														<td className="bold">{ Globals.formatMiles(accessories_price * quantity_of_days) }</td>
													</tr>
													<tr>
														<td className="text-left">Descuentos</td>
														<td className="bold">{ Globals.formatMiles(discount * quantity_of_days) }</td>
													</tr>
													{
														surcharges > 0 && (
															<tr>
																<td className="text-left">{ this.props.surcharge_title }</td>
																<td className="bold">{ Globals.formatMiles(surcharges) }</td>
															</tr>
														)
													}
													{
														journey_surcharge > 0 && (
															<tr>
																<td className="text-left">Recargo por Jornada</td>
																<td className="bold">{ Globals.formatMiles(journey_surcharge) }</td>
															</tr>
														)
													}
													<tr className="tr-border-top">
														<td className="text-left">Total a Cancelar $</td>
														<td className="bold">{ Globals.formatMiles(((price + accessories_price - discount) * quantity_of_days) + surcharges + journey_surcharge) }</td>
													</tr>
													<tr>
														<td className="text-left">Total a Cancelar Bs</td>
														<td className="bold">{ Globals.formatMiles(((price + accessories_price - discount) * quantity_of_days) + surcharges + journey_surcharge,true,Constants.CURRENCIES_SYMBOL.BOLIVAR,this.props.conversion?.amount || 0) }</td>
													</tr>
												</table>
											</div>
										</div>
									</div>
								</div>
								<div className="text-center">
									<Button type="submit" className="btn-submit-admin">
										Finalizar
									</Button>
								</div>
							</React.Fragment>
						)
					}

					{
						!this.state.form.client_id && (
							<p className="no-client-selected">Por favor, seleccione un cliente para continuar</p>
						)
					}

					{
						this.state.form.client_id && !this.state.form.service_id && (
							<p className="no-client-selected">Por favor, seleccione un tipo de servicio para continuar</p>
						)
					}
				</form>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user,
		conversion: state.conversion,
		surcharge_title: state.surcharge_title
	}
})(ModalCreate);